import httpServices from './httpServices'

// Each game has its own daily stage and its own board, but a solve always
// belongs to the person rather than to a group membership (see
// backend/models/PuzzleSolve.js). Only the leaderboard is group-scoped.

// Every game's state for today in one request — the hub and the app bar dot
// both need it, and four separate `today` calls for that is silly.
async function getStatus() {
    const response = await httpServices.get('/puzzle/status')
    return response.data
}

async function getToday(game) {
    const response = await httpServices.get(`/puzzle/games/${game}/today`)
    return response.data
}

// grid: the game's submission shape, durationMs: number (client-measured,
// paused while the tab is hidden — see hooks/usePuzzleGame.js)
async function solve(game, grid, durationMs) {
    const response = await httpServices.post(`/puzzle/games/${game}/solve`, { grid, durationMs })
    return response.data
}

async function hint(game, grid) {
    const response = await httpServices.post(`/puzzle/games/${game}/hint`, { grid })
    return response.data
}

async function getLeaderboard(groupId, game) {
    const response = await httpServices.get(`/puzzle/${groupId}/leaderboard/${game}`)
    return response.data
}

// Recording a challenge may also push a notification immediately, subject to
// the recipient's puzzleNudge preference and a per-recipient cooldown — not
// from an evening digest. See backend/services/puzzlePushService.js.
async function nudge(game, toUserId, groupId) {
    const response = await httpServices.post(`/puzzle/games/${game}/nudge`, { toUserId, groupId })
    return response.data
}

/** Ids this user has already challenged today, so the buttons come back right. */
async function getSentNudges(game) {
    const response = await httpServices.get(`/puzzle/games/${game}/nudges`)
    return response.data
}

export default {
    getStatus,
    getToday,
    solve,
    hint,
    getLeaderboard,
    nudge,
    getSentNudges,
}
